(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/cart-note
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Update a cart's note.
 * @copyright 2022 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("cart-note") === undefined) {
    class CartNote extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.querySelector("textarea")?.addEventListener("input", this.debounce(this.updateEvent.bind(this), 500));
        }
        debounce(callback, timeout) {
            let timer;
            return (...args)=>{
                clearTimeout(timer);
                timer = setTimeout(()=>callback.apply(this, args), timeout);
            };
        }
        updateEvent(event) {
            this.fetchConfig = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/javascript"
                }
            };
            this.fetchConfig.headers["X-Requested-With"] = "XMLHttpRequest";
            this.fetchConfig.body = JSON.stringify({
                note: event.target.value
            });
            fetch(`${routes.cart_update_url}`, this.fetchConfig);
        }
    }
    customElements.define("cart-note", CartNote);
}



})();
